export interface LinksModel {
  image: string;
  rlink: string;
  title: string;
  linkName: string;
}